import React from 'react';
import { useTranslation } from 'react-i18next';

import './ActionButton.scss';

type ActionButtonTranslationKey = 'play-for-free-capitals' | 'play-here' | 'claim-prize';

export interface ActionButtonProps {
  onClick: () => void;
  translationKey: ActionButtonTranslationKey;
}

const ActionButton = ({ onClick, translationKey }: ActionButtonProps) => {
  const { t } = useTranslation();
  return (
    <button onClick={onClick} className={`action-button --${translationKey}`}>
      {t(translationKey)}
    </button>
  );
};

export default ActionButton;
